<script setup>

import {onMounted, reactive, ref} from "vue";
import {useBreadStore} from '@bread/js/store'
import SalesFigures from "@admin_ui/Pages/Dashboard/Table/SalesFigures";
import MarginalGains from "@admin_ui/Pages/Dashboard/Table/MarginalGains";

onMounted(() => {
  store.setResource('dashboard')
})

const props = defineProps({
  sales: Object,
  filters: Object,
  stores: Array,
  products: Array,
  currentStore: Object,
})

const store = useBreadStore()

const params = reactive({
  search: props.filters.search,
  field: props.filters.field,
  direction: props.filters.direction,
  active: props.filters.active,
  store: props.currentStore.id,
})


const sort = (field) => {
  params.field = field;
  params.direction = params.direction === 'asc' ? 'desc' : 'asc';
}

const showFilters = ref(false)


onMounted(() => {
})


</script>

<template>
  <div>
    <sales-figures :sales="props.sales" :params="params"/>
    <marginal-gains :products="props.products" :params="params"/>
  </div>
</template>


<style scoped>
</style>
